import sanitizeHtml from 'sanitize-html'

import { stringifyQueryParams } from '@core/window/libs/url'

/**
 * <script> data attributes for fwn script
 * @param params
 * @returns
 */
export const getFwnDataAttributesObject = (params: Record<string, string>) => {
  return Object.fromEntries(
    Object.entries(params).map(([key, value]) => [
      `data-fwparam_${key}`,
      value,
    ]),
  )
}

/**
 * <fw-widget> attributes as key="value" string
 * @param params
 * @returns
 */
export const getFwnAttributesString = (params: Record<string, string>) => {
  return Object.entries(params)
    .map(([key, value]) => [
      sanitizeHtml(key.toString()),
      sanitizeHtml(value?.toString?.()).replace(/"/g, '\\"'),
    ])
    .map(([key, value]) => `${key}="${value}"`)
    .join(' ')
}

/**
 * <script> data attributes for fwn script as string
 * @param params
 * @returns
 */
export const getFwnDataAttributesString = (params: Record<string, string>) => {
  return Object.entries(params)
    .map(([key, value]) => [
      sanitizeHtml(key.toString()),
      sanitizeHtml(value?.toString?.()).replace(/"/g, '\\"'),
    ])
    .map(([key, value]) => `data-fwparam_${key}="${value}"`)
    .join(' ')
}

/**
 * Get link to common fwn script
 * @param fwnHost
 * @param params
 * @returns
 */
export const getFwnScriptUrl = (
  fwnHost: string,
  params?: Record<string, string>,
) => {
  return (
    `${fwnHost}/js/fwn.js` +
    (params ? stringifyQueryParams(params, { addQueryPrefix: true }) : '')
  )
}

/**
 * Get link to fwn module script
 * @param fwnHost
 * @param params
 * @returns
 */
export const getFwnModuleScriptUrl = (
  fwnHost: string,
  params?: Record<string, string>,
) => {
  return (
    `${fwnHost}/js/module/fwn.js` +
    (params ? stringifyQueryParams(params, { addQueryPrefix: true }) : '')
  )
}
